// extracted by mini-css-extract-plugin
export default {"title":"Catalog_title__MV+gB","items":"Catalog_items__FKa1f","itemsSlider":"Catalog_itemsSlider__w+e5j"};